import React, { useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import Sidebar from './components/Sidebar';
import IconTitle from './components/IconTitle';

import Home from './pages/Home';
import Contact from './pages/Contact';
import SocialRibbon from './components/SocialRibbon/SocialRibbon';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiscord } from '@fortawesome/free-brands-svg-icons';

import config from './data/config.json'

const App = () => {
  const [isLeftOpen, setIsLeftOpen] = useState(false);

  const toggleLeftSidebar = () => {
    setIsLeftOpen(!isLeftOpen);
  };

  return (
    <Router>
      <div style={{display: "flex", width: "100vw"}}>
        {/*         
        <Sidebar
          isOpen={isLeftOpen}
          config={config.sidebar}
          position="right"
          toggleSidebar={toggleLeftSidebar}
        >
          {isLeftOpen &&
            <>
              <Link to="/">
                <IconTitle 
                    iconName="waving_hand"
                    iconSize="2rem"
                    title="Hello"
                    isHidden={!isLeftOpen}
                    />
              </Link>
              <Link to="/contact">
                <IconTitle 
                    iconName="contact_support"
                    iconSize="2rem"
                    title="Contact Us"
                    isHidden={!isLeftOpen}
                    />
              </Link>
            </>
          }
        </Sidebar>
        */}
        <div id="main">
          <SocialRibbon config={config}/>
          <Header config={config}/>
          <div>
            <div className="discord-ribbon">
              <span className="">
                Uniting to bridge the tech gap.
              </span>
              <a className="quoteButton"
                href={`//discord.gg/${config.social.discord}`}
                target="_blank">
                  <FontAwesomeIcon icon={faDiscord} />
                  JOIN US ON DISCORD
              </a>
              <span className="">
                Explore digital realms in our growing Discord community!
              </span>
            </div>
          </div>
          <div className='page'>
            <Routes>
              <Route path="/" element={<Home config={config.pages.home} />} />
              <Route path="/contact" element={<Contact config={config.pages.contact} />} />
            </Routes>
          </div>
          <Footer showExtra={false} />
        </div>
      </div>
    </Router>
  );
}

export default App;
